// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:37:29

export default {
  "id": "quackventure",
  "slug": "quackventure",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/6120cf0775c44d05b9ade2ed8128c307-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/6120cf0775c44d05b9ade2ed8128c307/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Quackventure",
      "description": "Join Quack, the brave duck, on an exhilarating journey through a magical forest brimming with wonder and hidden secrets. Explore enchanting landscapes, solve intriguing mysteries, and embark on an adventure filled with thrilling surprises and endless excitement at every corner!",
      "instructions": "In Quackventure, you control a charming duck using the classic WASD keys and the Spacebar. Guide the duck as it navigates obstacles and flees from a menacing giant purple monster. Along the journey, collect power-ups to boost the duck’s abilities or unlock new skins to showcase your style. Can you lead the duck to safety while avoiding the hazards in your path?",
      "genres": [
        "Adventure"
      ],
      "tags": [
        "1player",
        "arcade",
        "escape",
        "platformer",
        "runner"
      ]
    },
    "zh-CN": {
      "title": "呱呱冒险",
      "description": "加入勇敢的鸭子Quack，踏上充满奇迹与隐藏秘密的神奇森林的激动人心的旅程。探索迷人的风景，解决引人入胜的谜题，在每个角落展开充满惊险惊喜和无限兴奋的冒险！",
      "instructions": "在《Quackventure》中，您将操控一只迷人的鸭子，使用经典的WASD键和空格键进行操作。引导鸭子避开障碍物，逃离一只令人畏惧的巨大紫色怪物。在旅途中，收集提升鸭子能力的道具或解锁新皮肤来展示您的风格。您能带领鸭子安全逃脱，避开前方的危险吗？",
      "genres": [
        "冒险"
      ],
      "tags": [
        "1玩家",
        "街机",
        "逃脱",
        "平台",
        "跑酷"
      ]
    },
    "zh-TW": {
      "title": "呱呱冒險",
      "description": "加入勇敢的鴨子Quack，踏上充滿驚喜的奇幻森林之旅，這裡充滿驚奇與隱藏的秘密。探索迷人的風光，解開迷人的謎團，並在每個轉角迎接驚險的驚喜和無盡的興奮！",
      "instructions": "在Quackventure中，您將操控一隻迷人的鴨子，使用經典的WASD鍵和空格鍵進行操作。引導鴨子通過障礙並逃離一隻令人恐懼的紫色巨人。在旅途中，收集強化物品來提升鴨子的能力或解鎖新外觀以展現您的風格。您能帶領鴨子安全到達目的地，並避開前方的危險嗎？",
      "genres": [
        "冒險"
      ],
      "tags": [
        "1人遊玩",
        "街機",
        "逃離",
        "平台",
        "跑酷"
      ]
    },
    "zh-HK": {
      "title": "蛙冒險",
      "description": "加入勇猛的小鴨Quack，踏上充满驚喜的奇幻森林之旅。探索迷人的風光，解開引人入勝的謎團，在每個角落都充滿驚險的驚喜和無盡的樂趣，展開一段冒險旅程！",
      "instructions": "在《Quackventure》中，你將操控一隻可愛的鴨子，使用經典的WASD鍵盤及空格鍵。引導鴨子穿越障礙物，逃離一隻威脅的巨大紫色怪物。在旅途中，收集提升能力的強化物品，或解鎖新外觀以展現你的風格。你能帶領鴨子到安全的地方，並避開前方的危險嗎？",
      "genres": [
        "冒險"
      ],
      "tags": [
        "1玩家",
        "街機",
        "逃離",
        "平台遊戲",
        "跑酷"
      ]
    },
    "ja": {
      "title": "クワックバンバー",
      "description": "クック、勇敢なカモと一緒に、驚きと隠された秘密に満ちた魔法の森を冒険する興奮的な旅に参加してください。魅力的な風景を探索し、興味深い謎を解き明かし、角のあちこちに驚きと興奮に満ちた冒険に出発してください！",
      "instructions": "Quackventureで、カラフルなカモをWASDキーとスペースバーを使って操作し、障害物を避け、恐ろしい紫色の巨大モンスターから逃げる。旅の途中で、カモの能力を強化するパワーアップアイテムを収集したり、スタイルをアピールする新しいスキンを解除したりする。あなたはカモを安全に導き、道の危険を避けることができますか？",
      "genres": [
        "アドベンチャー"
      ],
      "tags": [
        "1プレイヤー",
        "アーケード",
        "脱出",
        "プラットフォーム",
        "ランナー"
      ]
    },
    "ko": {
      "title": "퀭벤처",
      "description": "퀵, 용감한 거위와 함께 기적의 숲을 통해 열정적인 여정에 떠나세요. 경이롭고 숨겨진 비밀이 가득한 마법의 숲을 탐험하고, 매혹적인 풍경을 경험하세요. 궁금한 미스터리를 풀고, 각고지의 놀라운 놀이를 통해 끝없는 기쁨을 즐겨보세요!",
      "instructions": "Quackventure에서는 클래식 WASD 키와 공백 바를 사용하여 귀여운 퍼듀를 조종합니다. 퍼듀가 장애물을 통과하고 악명 높은 붉은 거대한 몬스터에서 도망치는 것을 안내하세요. 여정 동안 파워업을 수집하여 퍼듀의 능력을 강화하거나 새로운 스킨을 해금하여 스타일을 나타내세요. 퍼듀를 안전한 곳으로 이끌고 위험을 피할 수 있을까요?",
      "genres": [
        "모험"
      ],
      "tags": [
        "1플레이어",
        "아케이드",
        "탈출",
        "플랫폼게임",
        "런너"
      ]
    },
    "fr": {
      "title": "Quackventure",
      "description": "Rejoignez Quack, la sage canarde, pour une aventure captivante à travers une forêt magique débordante de merveilles et de secrets cachés. Explorez des paysages enchantés, résolvez des mystères intrigants et entrez dans une aventure remplit de surprises étonnantes et d'une excitation infinie à chaque coin !",
      "instructions": "Dans Quackventure, vous contrôlez un canard charmant en utilisant les touches classiques WASD et la barre d'espace. Guidez le canard tout en lui permettant de naviguer autour des obstacles et de fuir un monstre violet menaçant. Au fil de son voyage, collectez des power-ups pour améliorer les capacités du canard ou déverrouillez de nouvelles skins pour affirmer votre style. Pouvez-vous mener le canard à la sécurité tout en évitant les dangers sur votre chemin ?",
      "genres": [
        "Aventure"
      ],
      "tags": [
        "1 joueur",
        "arcade",
        "évasion",
        "plate-forme",
        "runner"
      ]
    }
  }
};
